<template>
  <self-render></self-render>
</template>

<script>
  import Vue from 'vue'
  import components from '../../../assets/js/self'
  export default {
    props: {
      iden: {
        type: String,
        default() {
          return ''
        }
      },
      selfData: {
        default() {
          return {}
        }
      }
    },
    data() {
      return {}
    },
    methods: {
      getSelfData(arr) {
        this.$emit('getSelfData', arr)
      }
    },
    created() {
      let self = this
      Vue.component('self-render', {
        render: function (h) {
          let children = []
          if (components) {
            _(components).forEach((res) => {
              if (res.iden == self.iden) {
                children.push(h(res,
                  {
                    props: { selfData: self.selfData },
                    on: {
                      getSelfData: self.getSelfData
                    }
                  }
                ))
              }
            })
          }
          return h('div', {}, children)
        }
      })
    }
  }
</script>


// WEBPACK FOOTER //
// selfRender.vue?08d2dfc4